
import { useState } from 'react';

export default function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const faqs = [
    {
      question: 'How much does piano removal cost in London?',
      answer:
        'Piano removal costs in London vary depending on the type of piano and specific requirements. Upright piano removals typically start from £149 for straightforward ground‑floor moves within the same borough. Baby grand piano removals begin at £320, while concert grand pianos start from £550. The final cost depends on several factors including the distance of the move, the floor level at both collection and delivery addresses, access challenges such as narrow staircases or tight doorways, and whether any special equipment like crane lifts are required. All reputable piano removal companies in London should provide a fixed‑price quote after assessing your specific situation.',
    },
    {
      question: 'How long does a London piano removal take?',
      answer:
        'A typical piano removal in London takes between 2 to 4 hours for local moves within the same borough. This includes the time needed for protective wrapping, careful loading, transportation, and placement at the destination. More complex moves involving multiple flights of stairs, difficult access, or longer distances across London may take 4 to 6 hours. Grand piano removals generally require more time due to the need for partial disassembly and reassembly. Your piano removal specialist will provide an accurate time estimate during the initial consultation.',
    },
    {
      question: 'Do piano removal companies in London cover all boroughs?',
      answer:
        "Reputable specialist piano removal companies in London typically cover all 32 London boroughs as part of their standard service area. This includes both inner and outer London locations from Westminster and Camden to Bromley and Havering. Many established piano removal specialists also extend their coverage to the surrounding Home Counties including Essex, Kent, Surrey, and Hertfordshire. When booking your piano removal, always confirm that your specific collection and delivery postcodes are within the company's service area to avoid any last‑minute complications.",
    },
  ];

  return (
    <section className="py-16 px-6 bg-white">
      <div className="max-w-4xl mx-auto">
        <h2 className="text-3xl md:text-4xl font-serif font-bold text-center mb-4 text-[#0e0d0b]">
          Frequently Asked Questions — Piano Removals London
        </h2>
        <div className="w-24 h-1 bg-[#c9a84c] mx-auto mb-12" />
        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="border border-[#c9a84c]/20 rounded-lg overflow-hidden"
            >
              <button
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className="w-full px-6 py-5 text-left flex items-center justify-between bg-[#f5f5f0] hover:bg-[#c9a84c]/5 transition-colors cursor-pointer"
                aria-expanded={openIndex === index}
                aria-controls={`faq-answer-${index}`}
              >
                <h4 className="text-lg font-semibold text-[#0e0d0b] pr-4">
                  {faq.question}
                </h4>
                <i
                  className={`ri-arrow-down-s-line text-2xl text-[#c9a84c] transition-transform ${
                    openIndex === index ? 'rotate-180' : ''
                  }`}
                  aria-hidden="true"
                />
              </button>
              {openIndex === index && (
                <div
                  id={`faq-answer-${index}`}
                  className="px-6 py-5 bg-white"
                >
                  <p className="text-[#1a1916] leading-relaxed">{faq.answer}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
